class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.annoucements = [];
    this.speed = 4;
  }

  connectedCallback() {
    this.annoucements = this.querySelectorAll('.announcement-bar__item');
    this.speed = this.getAttribute('data-speed') ?? 4;


    if(this.annoucements.length > 1 ) {
      this.init();
    }
  }

  init() {
    // Find the currently active announcement
    let currentIndex = Array.from(this.annoucements).findIndex(
      announcement => announcement.classList.contains('annoucement-bar__item--active')
    );
    
    // If no active announcement found, default to 0
    if (currentIndex === -1) {
      currentIndex = 0;
      this.annoucements[0].classList.add('annoucement-bar__item--active');
    }
    
    let interval;
    
    const showNextAnnouncement = () => {
      // Remove active class from current
      this.annoucements[currentIndex].classList.remove('annoucement-bar__item--active');
      
      // Move to next announcement (loop back to start if at end)
      currentIndex = (currentIndex + 1) % this.annoucements.length;
      
      // Add active class to next
      this.annoucements[currentIndex].classList.add('annoucement-bar__item--active');
    };
    
    const startInterval = () => {
      // Clear any existing interval first
      if (interval) {
        clearInterval(interval);
      }
      interval = setInterval(showNextAnnouncement, this.speed * 1000);
    };
    
    const pauseInterval = () => {
      if (interval) {
        clearInterval(interval);
      }
    };
    
    // Start the interval
    startInterval();
    
    // Pause on hover, resume on unhover
    this.addEventListener('mouseenter', pauseInterval);
    this.addEventListener('mouseleave', startInterval);
  }
}

customElements.define("announcement-bar", AnnouncementBar);


class Navbar extends HTMLElement {
  constructor() {
    super();
    this.menuItems = [];
    this.mobileMenuHamburger = null;
    this.mobileMenuClose = null;
    this.menuSearch = null;

    this.mobileMenu = null;
    this.header = null;
    this.dropdownHandlers = new Map();
    this._boundHandleResize = this._handleResize.bind(this);
  }

  connectedCallback() {
    this.mobileMenuHamburger = this.querySelector('[data-mobile-menu-hamburger]');
    this.mobileMenuClose = this.querySelector('[data-mobile-menu-close]');
    this.menuSearch = this.querySelector('search-element');
    this.mobileMenu = this.querySelector('.mobile-menu__menu');
    this.header = this.querySelector('.mobile-menu__header');
    this._initMobileMenuHamburger();
    this._initDropdowns();
    window.addEventListener('resize', this._boundHandleResize);
    this._handleBorderBottomIfHero();
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this._boundHandleResize);
    this._cleanupDropdownHandlers();
  }

  _initMobileMenuHamburger() {
    this.mobileMenuHamburger.addEventListener('click', () => {
      this.mobileMenu.classList.toggle('open');
      this.mobileMenuHamburger.classList.toggle('active');
      if(this.mobileMenu.classList.contains('open')) {
        const announcementBarHeight = document.querySelector('announcement-bar').offsetHeight;
        const headerHeight = this.header.offsetHeight + announcementBarHeight;
        this.mobileMenu.style.height = `calc(100vh - ${headerHeight}px)`;
      } 
    });
  }

  _handleBorderBottomIfHero() {
    let hero = null;
    const firstMainChild = document.querySelector('main').firstElementChild;


    console.log("🚀 ~ Navbar ~ _handleBorderBottomIfHero ~ firstMainChild:", firstMainChild)
    if(firstMainChild.id.includes('hero')) {
      hero = firstMainChild;
    } else {
      hero = firstMainChild.nextElementSibling;
    }

    if(hero.id.includes('hero')) {
      hero = null;
    }
    
    if(hero !== null) {
      document.querySelector('.navbar-divider').style.opacity = 1;
      document.querySelector('.mobile-menu__header').style.borderBottom = '1px solid #E4E2DB';
    }

    if(hero === null) {
      // if we start scrolling down, navbar-divider should be visible
      window.addEventListener('scroll', () => {
        if(window.scrollY > 100) {
          document.querySelector('.navbar-divider').style.opacity = 1;
          document.querySelector('.mobile-menu__header').style.borderBottom = '1px solid #E4E2DB';
        } else {
          document.querySelector('.navbar-divider').style.opacity = 0;
          document.querySelector('.mobile-menu__header').style.borderBottom = 'none';
        }
      });
    }
  }

  _handleResize() {
    this._initDropdowns();
  }

  _cleanupDropdownHandlers() {
    for (const [item, handlers] of this.dropdownHandlers.entries()) {
      if (handlers.anchorClick) {
        const anchorTag = item.querySelector('[data-link-menu="toggle"] a');
        if (anchorTag) {
          anchorTag.removeEventListener('click', handlers.anchorClick);
        }
      }
      if (handlers.itemClick) {
        item.removeEventListener('click', handlers.itemClick);
      }
      if (handlers.mouseEnter) {
        item.removeEventListener('mouseenter', handlers.mouseEnter);
      }
      if (handlers.mouseLeave) {
        item.removeEventListener('mouseleave', handlers.mouseLeave);
      }
    }
    this.dropdownHandlers.clear();
  }

  _initDropdowns() {
    this._cleanupDropdownHandlers();
    
    const menuItems = this.querySelectorAll('.navbar__menu__item');
    const isMobile = window.innerWidth < 768;
    
    for (const item of menuItems) {
      const toggle = item.querySelector('[data-link-menu="toggle"]');
      const linklist = item.querySelector('linklist-menu');
      
      if (toggle && linklist) {
        const anchorTag = toggle.querySelector('a');
        const handlers = {};
        
        if (isMobile) {
          if (anchorTag) {
            const anchorClickHandler = (event) => {
              // Prevent default link behavior on mobile when clicking the anchor tag inside data-link-menu="toggle"
              event.preventDefault();
            };
            anchorTag.addEventListener('click', anchorClickHandler);
            handlers.anchorClick = anchorClickHandler;
            item.addEventListener('click', () => this._toggleLinklist(toggle));
          }
        } else {
          const mouseEnterHandler = () => this._openLinklist(toggle);
          const mouseLeaveHandler = () => this._closeLinklist(toggle);
          
          item.addEventListener('mouseenter', mouseEnterHandler);
          item.addEventListener('mouseleave', mouseLeaveHandler);
          
          handlers.mouseEnter = mouseEnterHandler;
          handlers.mouseLeave = mouseLeaveHandler;
        }
        
        this.dropdownHandlers.set(item, handlers);
      }
    }
  }

  _toggleLinklist(toggle) {
    if (toggle) {
      toggle.classList.toggle('open');
    }
  }

  _openLinklist(toggle) {
    if (toggle) {
      toggle.classList.add('open');

      const parent = toggle.parentElement;
      const previousSibling = parent.previousElementSibling;

      let minusWidth = 0;
      if(previousSibling) {
        minusWidth = previousSibling.offsetWidth + 32;
      }

      parent.querySelector('linklist-menu').style.setProperty('--left-after', `-${minusWidth}px`);
    }
  }

  _closeLinklist(toggle) {
    if (toggle) {
      toggle.classList.remove('open');
    }
  }
}

customElements.define("navbar-new", Navbar);